import { FormattedMessage } from "react-intl";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

export default function BreakReasonConfirmDialog(props) {
  const {
    open,
    handleOpenOrClose,
    onSave,
    activeBreakReasonData
  } = props;

  const reasonName = activeBreakReasonData && activeBreakReasonData?.reasonbreak ? activeBreakReasonData?.reasonbreak?.name : '';

  async function handleOnSave(e) {
    try {
      e.preventDefault();

      await onSave(activeBreakReasonData);
      handleOpenOrClose();
    }
    catch (err) {
      throw err;
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleOpenOrClose}
      aria-labelledby="break-reason-confirm-dialog"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="break-reason-confirm-title">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <FormattedMessage id="confirm" />
          <IconButton aria-label="close" size="small" onClick={handleOpenOrClose}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography>
          <FormattedMessage
            id="break.reason.dialog.confirmation"
            defaultMessage="break.reason.dialog.confirmation"
            values={{
              reasonName:
                <>
                  {' '}
                  <strong>'{reasonName}'</strong>
                  <br />
                </>
            }}
          />
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button
            variant='outlined'
            color='primary'
            onClick={handleOpenOrClose}
            sx={{ minWidth: 100 }}
          >
            <FormattedMessage id="cancel" />
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleOnSave}
            sx={{ minWidth: 100 }}
          >
            <FormattedMessage id="confirm" />
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
